import type { ActionResponse } from '@acme/api';

const CONFIRM_TYPE_MODALS: Record<string, { title: string; content: string }> =
  {
    Application_AuthorizedOrganizationFromDraft: {
      title: 'Подтвердить заявку',
      content:
        'После подтверждения заявки, вы перейдете к заполнению данных о комиссии',
    },
  };

export function getConfirmModalFromAction(action: ActionResponse | null) {
  const confirmType = action?.arguments?.confirmType;
  if (typeof confirmType === 'string' && CONFIRM_TYPE_MODALS[confirmType]) {
    return CONFIRM_TYPE_MODALS[confirmType];
  }
  return null;
}
